let _ = t => t,
  _t,
  _t2;
import styled from 'styled-components';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
export const BizObjHeaderLink = styled(UIButton).withConfig({
  displayName: "BusinessObjectivesStyledComponents__BizObjHeaderLink",
  componentId: "sc-1kga6v1-0"
})(["font-weight:700 !important;text-transform:uppercase;margin-left:0 !important;margin-bottom:4px !important;font-size:13px;color:", " !important;", ";"], CALYPSO_DARK, breakpoint.tablet(_t || (_t = _`
    color: ${0};
  `), CALYPSO_DARK));
export const BizObjHeaderNoLink = styled.h6.withConfig({
  displayName: "BusinessObjectivesStyledComponents__BizObjHeaderNoLink",
  componentId: "sc-1kga6v1-1"
})(["font-weight:700 !important;text-transform:uppercase;margin-left:0 !important;margin-bottom:4px !important;font-size:13px;color:", " !important;", ";"], CALYPSO_DARK, breakpoint.tablet(_t2 || (_t2 = _`
    color: ${0};
  `), CALYPSO_DARK));
export const BizLowerTierContainer = styled.div.withConfig({
  displayName: "BusinessObjectivesStyledComponents__BizLowerTierContainer",
  componentId: "sc-1kga6v1-2"
})(["font-size:14px;line-height:19px;padding-bottom:12px;"]);